import  { useState } from "react";
import { Card, CardBody, CardHeader, Col, Row, Label, Input } from "reactstrap";
import Select from "react-select";

const SingleOptions = [
  { value: "Choices 1", label: "Choices 1" },
  { value: "Choices 2", label: "Choices 2" },
  { value: "Choices 3", label: "Choices 3" },
  { value: "Choices 4", label: "Choices 4" },
];


function handleSelectSingle(selectedSingle) {
  setSelectedSingle(selectedSingle);
}

const FormularioPerfilUsuario = () => {
    const [selectedSingle, setSelectedSingle] = useState({
  value: "Choices 1",
  label: "Choices 1",
});
  return (
    <Row>
      <Col lg={12}>
        <Card>
          <CardHeader title="Usuario" />

          <CardBody className="card-body">
            <Row className="gy-4">
              <Col xxl={3} md={6}>
                <div>
                  <Label htmlFor="usuario" className="form-label">
                    Usuario
                  </Label>
                  <Input
                    type="text"
                    className="form-control"
                    id="usuario"
                    placeholder="Usuario"
                  />
                </div>
              </Col>

              <Col xxl={3} md={6}>
                <div>
                  <Label htmlFor="password" className="form-label">
                    Contraseña
                  </Label>
                  <Input
                    type="password"
                    className="form-control"
                    id="password"
                    placeholder="Contraseña"
                  />
                </div>
              </Col>

              <Col xxl={3} md={6}>
                <div>
                  <Label htmlFor="passwordRepeat" className="form-label">
                    Repetir contraseña
                  </Label>
                  <Input
                    type="password"
                    className="form-control"
                    id="passwordRepeat"
                    placeholder="Contraseña"
                  />
                </div>
              </Col>

              <Col xxl={3} md={6}>
                <div>
                  <Label htmlFor="nombreCompleto" className="form-label">
                    Nombre completo
                  </Label>
                  <Input
                    type="text"
                    className="form-control"
                    id="nombreCompleto"
                  />
                </div>
              </Col>

              <Col xxl={3} md={6}>
                <div className="mb-3">
                  <Label htmlFor="perfil" className="form-label">
                    Perfil
                  </Label>
                  <Select
                    id="perfil"
                    placeholder="Seleccionar..."
                    value={selectedSingle}
                    onChange={() => {
                      handleSelectSingle();
                    }}
                    options={SingleOptions}
                  />
                </div>
              </Col>
              <Col xxl={3} md={6}>
                <div className="mb-3">
                  <Label htmlFor="iniciar" className="form-label">
                    Iniciar
                  </Label>
                  <Select
                    id="iniciar"
                    placeholder="Seleccionar..."
                    value={selectedSingle}
                    onChange={() => {
                      handleSelectSingle();
                    }}
                    options={SingleOptions}
                  />
                </div>
              </Col>
              <Col xxl={3} md={6}>
                <div className="mb-3">
                  <Label htmlFor="empresa" className="form-label">
                    Empresa
                  </Label>
                  <Select
                    id="empresa"
                    placeholder="Seleccionar..."
                    value={selectedSingle}
                    onChange={() => {
                      handleSelectSingle();
                    }}
                    options={SingleOptions}
                  />
                </div>
              </Col>
              <Col xxl={3} md={6}>
                <div className="mb-3">
                  <Label htmlFor="departamento" className="form-label">
                    Departamento
                  </Label>
                  <Select
                    placeholder="Seleccionar..."
                    id="departamento"
                    value={selectedSingle}
                    onChange={() => {
                      handleSelectSingle();
                    }}
                    options={SingleOptions}
                  />
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default FormularioPerfilUsuario;
